export var licenseStatusUrlFormat = '{0}/api/license/data?app={1}&scenarioId={2}';
export var licenseStatusQueryKeyPreFix = 'LicenseStatus_';
//# sourceMappingURL=constants.js.map